import { render, staticRenderFns } from "./DashboardRevenue.vue?vue&type=template&id=ff20e4fe&"
import script from "./DashboardRevenue.vue?vue&type=script&lang=js&"
export * from "./DashboardRevenue.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRevenue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports